import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(({ spacing, breakpoints }) => ({
  paper: {
    marginTop: spacing(2),
    [breakpoints.up('sm')]: {
      marginTop: spacing(3),
    },
  },
}));
